// Thin wrapper around Google Analytics 4 gtag + PostHog capture.
// Safe to call even if the tags haven't loaded yet — both check for existence
// and fail silently in dev / when blocked by ad blockers.

export const track = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch (_) { /* noop */ }
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, params);
    }
  } catch (_) { /* noop */ }
};
